<template>
	<sa-page-layout :showModalLoading="showModalLoading" class="sa-no-space">
		<template slot="toolbar">
			<b-button variant="outline-primary btn-toolbar sa-margin-left float-sm-left" @click="onClickLeggiPratiche">
				<i class="fas fa-cloud-download-alt"></i>
				Carica Pratiche
			</b-button>
		</template>
		<template slot="table-body">
			<siat-lettura-piani-assegnati-component ref="cmpSiatLetturaPianiAssegnatiComponent"></siat-lettura-piani-assegnati-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import SiatLetturaPianiAssegnatiComponent from "../components/SiatLetturaPianiAssegnatiComponent.vue";
export default {
	components: { SaPageLayout, SiatLetturaPianiAssegnatiComponent },
	data() {
		return {
			showModalLoading: false,
			pathResource: "/dataanalysisdashboard",
			linkback: "/dataanalysisdashboards",
			jsonData: {},
		};
	},
	methods: {
		onClickLeggiPratiche() {
			this.$refs.cmpSiatLetturaPianiAssegnatiComponent.loadData();
		},
	},
};
</script>

<style></style>
